// MailTemplate Form Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Tab from '../../../common/layout/tab/tab.jsx'
import TabPanel from '../../../common/layout/tab_panel/tab_panel.jsx'
import Button from '../../../common/common/button/button.jsx'
import MailTemplateItem from '../mailtemplate_item/mailtemplate_item.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import MailtemplateUtil from '../../../lib/mailtemplateutil.jsx'

class MailTemplateForm extends Component {
  constructor (props) {
    super(props)

    this.state = {
      dataDate: null
    }

    this.data = {
      stepIndex: 0,
      templates: [
        { ident: 'estimate', title: 'estimate' },
        { ident: 'invoice', title: 'invoice' },
        { ident: 'purchaseorder', title: 'purchaseorder' },
        { ident: 'invoice-resend', title: 'invoiceresend' }
      ],
      tabs: [
        { title: 'setting.mailTemplate.labelEnglish', lang: 'en' },
        { title: 'setting.mailTemplate.labelGerman', lang: 'de' },
        { title: 'setting.mailTemplate.labelDutch', lang: 'nl' }
      ]
    }

    const currLanguage = IntlUtil.getLang()
    if (currLanguage !== 'us') {
      const currIdx = ['en', 'de', 'nl'].indexOf(currLanguage)
      const currTab = this.data.tabs[currIdx]
      this.data.tabs.splice(currIdx, 1)
      this.data.tabs.splice(0, 0, currTab)
    }

    this._activeEditor = null
  }

  static get propTypes () {
    return {
      onSubmit: PropTypes.func,
      mailTemplate: PropTypes.object,
      defaultTemplate: PropTypes.object,
      country: PropTypes.string,
      isQuickbookConnected: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      onSubmit: null,
      mailTemplate: null,
      defaultTemplate: null,
      country: '',
      isQuickbookConnected: false
    }
  }

  render () {
    const tabIndex = this.data.stepIndex
    const currLang = this._getCurrentLanguage(tabIndex)
    const variables = MailtemplateUtil.getVariablesList(currLang)
    let contentLang = ''

    if (this.props.country === 'UK') {
      contentLang = 'en'
    } else if (this.props.country === 'US') {
      contentLang = 'us'
    }

    return (
      <div className='mailtemplate-form'>
        <div className='colleft'>
          <h3 className='title'>
            <IntlMessage ident='setting.mailTemplate.titleMailTemplate' />
          </h3>
          <div className='content'>
            <span className='info'>
              <IntlMessage ident='setting.mailTemplate.infoMessage' />
            </span>
            <span className='info'>
              <IntlMessage ident='setting.mailTemplate.infoAutofill' />
            </span>
            <span className='info'>
              <IntlMessage ident='setting.mailTemplate.infoRefreshMessage' />
            </span>
            <div className='data'>
              {variables.map((variable, idx) => (
                <div className='variable' key={idx}>
                  <span
                    className='label'
                    onClick={this._onClickVariable.bind(
                      this,
                      MailtemplateUtil.getTranslatedName(
                        currLang,
                        variable.name
                      )
                    )}
                  >
                    [
                    {MailtemplateUtil.getTranslatedName(
                      currLang,
                      variable.name
                    )}
                    ]
                  </span>
                  <span className='value'>{variable.example}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className='colright'>
          <form
            className='mailform'
            method='post'
            noValidate
            action='#'
            onSubmit={this.props.onSubmit}
          >
            <div className='formcontent'>
              <div className='tabcontent'>
                {this.props.country !== 'UK' && this.props.country !== 'US' ? (
                  <Tab onChange={this._onChangeTab.bind(this)} showFullBorder>
                    {this.data.tabs.map((tabInfo, idx) => (
                      <TabPanel
                        title={tabInfo.title}
                        key={idx}
                        active={tabIndex === idx}
                      >
                        {this._renderTemplateItems(tabInfo.lang)}
                      </TabPanel>
                    ))}
                  </Tab>
                ) : (
                  this._renderTemplateItems(contentLang)
                )}
              </div>
            </div>
            <Button
              className='button_save button_view'
              title='setting.mailTemplate.titleSave'
              canHover={false}
              type='button'
              icon='common-success-tick'
              onClick={this.props.onSubmit}
            />
          </form>
        </div>
      </div>
    )
  }

  /* Private functions */
  _renderTemplateItems (lang) {
    const { isQuickbookConnected } = this.props
    return this.data.templates.map((templateInfo, idx) => {
      const templateObj = this._getTemplateObject(templateInfo.ident, lang)
      const title = `setting.mailTemplate.${lang}${templateInfo.title}Title`
      const subjectLabel = `setting.mailTemplate.${lang}Subject`

      if (
        isQuickbookConnected &&
        (templateObj.ident === 'invoice' ||
          templateObj.ident === 'invoice-resend')
      ) {
        return null
      }

      return (
        <MailTemplateItem
          key={idx}
          title={title}
          subjectLabel={subjectLabel}
          template={templateObj}
          onReset={this._onResetItem.bind(this, lang, templateObj.ident)}
          autocompleteOptions={this._getAutocompleteOptions(templateInfo.ident)}
          onFocusEditor={this._onFocusEditor.bind(this)}
          canAttachTerms={this._getAttachTerms(templateInfo.ident)}
          onChangeAttachTerms={this._onChangeAttachTerms.bind(
            this,
            templateInfo.ident
          )}
          onChangeincludeAltSupportfooter={this._onChangeincludeAltSupportfooter.bind(
            this,
            templateInfo.ident,
            lang
          )}
        />
      )
    })
  }

  _getTemplateObject (ident, lang) {
    let templateObj = _.find(
      this.props.mailTemplate[lang],
      template => template.ident === ident
    )

    if (templateObj) {
      templateObj.bDefault = false
      return templateObj
    }

    // Team template object doenst have template data for given ident
    // So copy from default template data and store in team tempalte data
    templateObj = _.find(
      this.props.defaultTemplate[lang],
      template => template.ident === ident
    )
    if (templateObj) {
      const newObj = _.cloneDeep(templateObj)
      newObj.bDefault = true
      this.props.mailTemplate[lang].push(newObj)

      return newObj
    }

    return {
      ident: ident,
      subject: '',
      content: '',
      bDefault: true,
      includeAltSupportfooter: false
    }
  }

  _getAttachTerms (ident) {
    const attachTerms = this.props.mailTemplate.attachTerms || []
    return attachTerms.indexOf(ident) !== -1
  }

  _onChangeTab (tabIndex) {
    this.data.stepIndex = tabIndex
    this.setState({ dataDate: new Date() })
  }

  _onChangeAttachTerms (ident, bChecked) {
    const attachTerms = this.props.mailTemplate.attachTerms || []

    _.remove(attachTerms, attachTerm => attachTerm === ident)

    if (bChecked) {
      attachTerms.push(ident)
    }

    this.props.mailTemplate.attachTerms = attachTerms
    this._refresh()
  }

  _onChangeincludeAltSupportfooter (ident, lang, isChecked) {
    const index = this.props.mailTemplate[lang].findIndex(v => v.ident === ident)

    this.props.mailTemplate[lang][index].includeAltSupportfooter = isChecked
    this._refresh()
  }

  _refresh () {
    this.setState({ dataDate: new Date() })
  }

  /* Event handlers */
  _onResetItem (lang, ident) {
    // On Reset - delete the template from team template data
    _.remove(
      this.props.mailTemplate[lang],
      template => template.ident === ident
    )

    this._refresh()
  }

  _onClickVariable (vaiableName, _ev) {
    if (this._activeEditor) {
      this._activeEditor.insertHtml(`[${vaiableName}]`)
    }
  }

  _onFocusEditor (editorComp) {
    this._activeEditor = editorComp
  }

  _getAutocompleteOptions (ident) {
    let variables = [
      'CompanyName',
      'ContactPerson',
      'FirstName',
      'LastName',
      'ProjectName',
      'Amount',
      'EstimateNumber'
    ]
    if (ident === 'invoice' || ident === 'invoice-resend') {
      variables = [
        'CompanyName',
        'ContactPerson',
        'FirstName',
        'LastName',
        'ProjectName',
        'Amount',
        'InvoiceNumber',
        'DueDate'
      ]
    } else if (ident === 'purchaseorder') {
      variables = [
        'ContactPerson',
        'FirstName',
        'LastName',
        'ProjectName',
        'PONumber'
      ]
    }

    // Build data to be used in At.JS config.
    var options = variables.map((variableName, i) => {
      const currLang = this._getCurrentLanguage(this.data.stepIndex)
      const transVarName = MailtemplateUtil.getTranslatedName(
        currLang,
        variableName
      )

      return {
        id: i,
        name: transVarName + ']',
        value: transVarName
      }
    })

    return options
  }

  _getCurrentLanguage (currIndex) {
    const currLanguage = IntlUtil.getLang()
    if (currLanguage === 'us') {
      return 'us'
    }

    return this.data.tabs[currIndex].lang
  }
}

export default MailTemplateForm
